import { render, staticRenderFns } from "./TopicsIndex.vue?vue&type=template&id=2aae6f12&scoped=true"
import script from "./TopicsIndex.vue?vue&type=script&lang=js"
export * from "./TopicsIndex.vue?vue&type=script&lang=js"
import style0 from "./TopicsIndex.vue?vue&type=style&index=0&id=2aae6f12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aae6f12",
  null
  
)

export default component.exports